export enum OrganizationPermissionStatusEnum {
  Access = 'ACCESS',
  Limited = 'LIMITED',
  Deny = 'DENY',
}
